export default "__VITE_ASSET__3wPPTjYE__"